/**
 * AvatarImage.tsx - Avatar Display Component
 *
 * Reusable avatar component with fallback to initials.
 */

import { useAuthContext } from '@/contexts/AuthContext';
import { Avatar, ConditionalValue, HStack } from '@chakra-ui/react';

interface AvatarImageProps {
    avatarFallbackName: string;
    avatarImageUrl: string;
    size: ConditionalValue<"sm" | "md" | "lg" | "xl" | "2xl" | "full" | "2xs" | "xs">;
}

export const AvatarImage: React.FC<AvatarImageProps> = ({ avatarFallbackName, avatarImageUrl, size }) => {

    return (
        <>
            <HStack margin={2}>
                {/*<Heading fontWeight="normal">{circle.group.name}</Heading>*/}
                <Avatar.Root size={size} background={"white"}>
                    <Avatar.Fallback name={avatarFallbackName} />
                    <Avatar.Image src={avatarImageUrl} />
                </Avatar.Root>
            </HStack>
        </>
    );
}
